import { useEffect, useState } from 'react'
import { IAccreditation, IPostAccreditation } from '../../../shared/services/accreditations/accreditations.model';
import { IHeadCell } from '../../../shared/interfaces/table-display.model';
import { PageOuterContainer } from '../../../root-components/layouts/page-outer-container';
import { PageHeading } from '../../presentation-components/display-elements-components/page-heading';
import { LoadingPage } from '../loading-page';
import { TableDisplay } from '../../presentation-components/miscellaneous-components/table-display';
import { TableActionButtons } from '../../presentation-components/miscellaneous-components/table-action-buttons';
import { IconName } from '../../../shared/interfaces/icon-picker.model';
import { AccreditationDialog } from '../../dialogs/super-admin/add-new-accreditation-dialog';
import AccreditationsService from '../../../shared/services/accreditations/accreditations.service';

export const SuperAdminAccreditationsPage = () => {
  //Services
  const accreditationService = new AccreditationsService();
  //State
  const [value, setValue] = useState(0);
  const [accreditations, setAccreditations] = useState<IAccreditation[]>([]);
  const [selectedAccreditationId, setSelectedAccreditationId] = useState<string>('');
  //Table State
  const [selected, setSelected] = useState<string[]>([]);
  const [inputPage, setInputPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0)
  const [perPage, setPerPage] = useState(10)
  const [change, setChange] = useState<number>(0)
  const [openDialog, setOpenDialog] = useState(false);
  //Loading State
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [hasPageMounted, setHasPageMounted] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    getAllAccreditations()
  }, [inputPage, perPage, change])

  useEffect(() => {
    if (hasPageMounted) {
      if (inputPage === 0) {
        setChange(change + 1)
      } else {
        setInputPage(0)
      }
    }
    setHasPageMounted(true)
  }, [value])


  const getAllAccreditations = () => {
    accreditationService.getAllWithPagination(inputPage, perPage)
      .then(response => {
        setTotalRecords(response.count)
        setIsLoading(false)
        setAccreditations(response.rows)
      })
      .catch(err => {
        setIsLoading(false)
        console.log(err)
      })
  }

  const headCells: IHeadCell[] = [
    { id: 'action', numeric: false, label: 'Action', sortable: false, includeInMobile: false },
    { id: 'name', numeric: false, label: 'Name', sortable: false, isHeading: true },
    { id: 'detail', numeric: false, label: 'Details', sortable: false },
  ];

  const rows = accreditations.map(accreditation => {
    return {
      id: accreditation.id,
      name: accreditation.name,
      detail: accreditation.detail,
      action: (
        <TableActionButtons
          id={accreditation.id}
          includeEdit={true}
          onEdit={() => editClickHandler(accreditation.id)}
        />
      )
    }
  });

  const editClickHandler = (accreditationId: string) => {
    setSelectedAccreditationId(accreditationId)
    setOpenDialog(true)
  }

  const submitHandler = (values: IPostAccreditation, resetForm: () => void, isEdit: boolean, accreditationId?: string) => {
    if (isEdit && accreditationId) {
      setIsSubmitting(true)
      accreditationService.edit(accreditationId, values)
        .then(response => {
          getAllAccreditations()
          resetForm()
          setIsSubmitting(false)
          setOpenDialog(false)
        })
        .catch(err => {
          setIsSubmitting(false)
          console.log(err)
        })
    }
    else {
      accreditationService.create(values)
        .then(response => {
          getAllAccreditations()
          setIsSubmitting(false)
          resetForm()
          setOpenDialog(false)
        })
        .catch(err => {
          setIsSubmitting(false)
          console.log(err)
        })
    }
  }
  return (
    <PageOuterContainer>
      <PageHeading
        title='Super Admin Verifiers'
        includeBackButton={true}
        backButtonLink='/super-admin'
        backButtonText='Back to super admin'
        includeActionButton={true}
        actionButtonIcon={IconName.Add}
        actionButtonHandler={() => setOpenDialog(true)}
        actionButtonText='Add Verifier'
      />
      <LoadingPage pageReady={!isLoading}>
        {accreditations &&
          <TableDisplay
            headCells={headCells}
            rows={rows}
            selectByIcon={true}
            selected={selected}
            setSelected={setSelected}
            inputPage={inputPage}
            setInputPage={setInputPage}
            totalRecords={totalRecords}
            perPage={perPage}
            setPerPage={setPerPage}
          />
        }
        {openDialog && selectedAccreditationId &&
          <AccreditationDialog
            open={openDialog}
            isEdit={true}
            isSubmitting={isSubmitting}
            onSubmit={submitHandler}
            accreditationId={selectedAccreditationId}
            closeHandler={() => setOpenDialog(false)}
          />
        }
        {
          openDialog && !selectedAccreditationId &&
          <AccreditationDialog
            isSubmitting={isSubmitting}
            onSubmit={submitHandler}
            open={openDialog}
            isEdit={false}
            closeHandler={() => setOpenDialog(false)}
          />
        }
      </LoadingPage>
    </PageOuterContainer>)
}